import { render, staticRenderFns } from "./BigUserRulesPage.vue?vue&type=template&id=6b4f87be&scoped=true"
import script from "./BigUserRulesPage.vue?vue&type=script&lang=js"
export * from "./BigUserRulesPage.vue?vue&type=script&lang=js"
import style0 from "./BigUserRulesPage.vue?vue&type=style&index=0&id=6b4f87be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4f87be",
  null
  
)

export default component.exports